module.exports = __webpack_public_path__ + "img/downloadimage.69dc3386.png";